<template>
    <div
         class="fixed inset-0 z-[2147482990] grid place-items-center bg-background/80 text-foreground pointer-events-auto">
        <div class="spinner-elem flex items-center justify-center">
            <div class="border-primary h-10 w-10 animate-spin rounded-full border-b-2 border-t-2"></div>
        </div>
    </div>
</template>